import { render, staticRenderFns } from "./ChallengePartnerForm.vue?vue&type=template&id=010f0920&scoped=true&"
import script from "./ChallengePartnerForm.vue?vue&type=script&lang=js&"
export * from "./ChallengePartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePartnerForm.vue?vue&type=style&index=0&id=010f0920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f0920",
  null
  
)

export default component.exports